'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function bindEvent(options, page) {
  var Events = [];

  function bindTouchMove() {
    var startPos = {};
    var movePos = {};
    var diffX = void 0;
    var diffY = void 0;
    var touch = void 0;
    var onceTouch = false;

    var threshold = options.threshold;
    var isVertical = void 0;

    function touchstartHandle(event) {
      onceTouch = true;

      startPos = {};
      if (event.target.tagName.toLowerCase() !== 'a') {
        event.preventDefault();
      }
      touch = event.touches[0];
      startPos.x = touch.pageX;
      startPos.y = touch.pageY;
    }

    function touchmoveHandle(event) {
      event.preventDefault();
      touch = event.touches[0];
      movePos.x = touch.pageX;
      movePos.y = touch.pageY;
      diffX = startPos.x - movePos.x;
      diffY = startPos.y - movePos.y;

      if (page.isScrolling || !onceTouch) {
        return false;
      }

      isVertical = Math.abs(diffX) - Math.abs(diffY) <= 0;

      onceTouch = Math.max(diffX, diffY) <= threshold;
      if (!isVertical) {
        if (diffX > threshold) {
          page.slide.next();
        } else if (diffX < -threshold) {
          page.slide.pre();
        }
      } else {
        if (diffY > threshold) {
          page.move.next();
        } else if (diffY < -threshold) {
          page.move.pre();
        }
      }
    }

    function touchendHandle(event) {
      if (event.target.tagName.toLowerCase() !== 'a') {
        event.preventDefault();
      }

      onceTouch = true;
    }

    document.addEventListener('touchstart', touchstartHandle, false);

    document.addEventListener('touchmove', touchmoveHandle, false);

    document.addEventListener('touchend', touchendHandle, false);
  }

  function bindMouseWheel() {
    var type = void 0;
    var deltaY = void 0;

    if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
      type = 'DOMMouseScroll';
    } else {
      type = 'mousewheel';
    }

    function mouseWheelHandle(event) {
      if (page.isScrolling) {
        return false;
      }
      deltaY = event.detail || -event.wheelDelta || event.deltaY;
      if (deltaY > 0) {
        page.move.next();
      } else if (deltaY < 0) {
        page.move.pre();
      }
    }

    document.addEventListener(type, mouseWheelHandle, false);
  }

  function bindKeyboard() {
    function keyboardHandle(event) {
      var key = event.keyCode || event.which;
      switch (key) {
        case 37:
          page.slide.pre();
          break;
        case 38:
          page.move.pre();
          break;
        case 39:
          page.slide.next();
          break;
        case 40:
          page.move.next();
          break;
      }
    }

    document.addEventListener('keydown', keyboardHandle, false);
  }

  Events.push(bindTouchMove, bindKeyboard, bindMouseWheel);

  Events.forEach(function (now) {
    now();
  });
}

exports.default = bindEvent;




//////////////////
// WEBPACK FOOTER
// ./~/notone/events.js
// module id = 627
// module chunks = 2